import { render, staticRenderFns } from "./detailNews.vue?vue&type=template&id=25174b93&scoped=true&"
import script from "./detailNews.vue?vue&type=script&lang=js&"
export * from "./detailNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25174b93",
  null
  
)

export default component.exports